import { topics } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

const heatStyle: Record<string, string> = {
  热: "border-primary-200 bg-primary-50 text-primary-900 hover:bg-primary-100",
  新: "border-accent-300 bg-accent-50 text-accent-900 hover:bg-accent-100",
  "": "border-background-200 bg-background-50 text-foreground-700 hover:border-secondary-300 hover:bg-secondary-50",
};

export default function TopicWall() {
  return (
    <section className="border-b border-background-200 bg-background-50 scroll-mt-32">
      <div className="px-4 md:px-6 py-8 md:py-12">
        <SectionHeading
          id="topics"
          index="03"
          title="话题墙"
          subtitle="本轮被反复提起的关键词，点一下就能顺着线索翻下去"
          actionText="进入话题总览"
        />

        <div className="mt-6 flex flex-wrap gap-2 md:gap-3">
          {topics.map((topic, index) => (
            <a
              key={topic.name}
              href="#topics"
              className={`inline-flex items-center gap-2 rounded-full border px-3.5 py-2 transition-colors cursor-pointer whitespace-nowrap ${
                heatStyle[topic.heat] ?? heatStyle[""]
              } ${index < 4 ? "text-sm md:text-base" : "text-xs md:text-sm"}`}
            >
              <span className="text-foreground-400">#</span>
              {topic.name}
              {topic.heat === "热" && (
                <span className="rounded-full bg-primary-500 px-1.5 py-0.5 text-[10px] leading-none text-background-50">
                  热
                </span>
              )}
              {topic.heat === "新" && (
                <span className="rounded-full bg-accent-500 px-1.5 py-0.5 text-[10px] leading-none text-background-50">
                  新
                </span>
              )}
            </a>
          ))}
        </div>

        <div className="mt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 rounded-lg border border-background-200 bg-background-100/70 p-4 md:p-5">
          <p className="text-sm text-foreground-600">
            话题墙按讨论热度实时排布，<strong className="font-medium text-foreground-900">越靠前越热</strong>。
          </p>
          <span className="flex items-center gap-2 text-xs text-foreground-500">
            <i className="ri-refresh-line text-accent-600"></i>
            最近更新：2 分钟前
          </span>
        </div>
      </div>
    </section>
  );
}